import React from 'react'
import { Virtuoso, VirtuosoHandle, VirtuosoProps } from 'react-virtuoso'
import { light } from '~/constants/theme'

interface InfiniteListProps<ItemData, Context>
  extends VirtuosoProps<ItemData, Context> {
  virtuosoRef?: React.RefObject<VirtuosoHandle>
  onEndReached?: ((index?: number) => void) | null
  listItem: (index: number, data: ItemData) => React.ReactNode
  style?: React.CSSProperties
}
const InfiniteList = <ItemData, Context>({
  data,
  virtuosoRef,
  onEndReached,
  listItem,
  style,
  ...props
}: InfiniteListProps<ItemData, Context>) => {
  return (
    <Virtuoso
      ref={virtuosoRef}
      {...props}
      data={data}
      totalCount={data?.length}
      overscan={500}
      endReached={onEndReached ?? undefined}
      itemContent={listItem}
      style={{
        backgroundColor: `${light.gray200}`,
        minHeight: '180px',
        ...style,
      }}
    />
  )
}

export default InfiniteList
